import React from 'react';
import { FadeIn } from './FadeIn';
import { Droplets, Pill, BedDouble } from 'lucide-react';
export function PainPoints() {
  const points = [{
    icon: <Droplets className="w-10 h-10 text-brand-terracotta" data-id="element-134" />,
    text: '¿Usa cremas que prometen mucho pero no penetran el tejido?'
  }, {
    icon: <Pill className="w-10 h-10 text-brand-terracotta" data-id="element-135" />,
    text: '¿Toma analgésicos que le dañan el estómago sin sanar la articulación?'
  }, {
    icon: <BedDouble className="w-10 h-10 text-brand-terracotta" data-id="element-136" />,
    text: '¿Le dijeron que descanse, pero su rodilla cada día está más rígida?'
  }];
  return <section className="py-20 px-6 bg-white" data-id="element-137">
      <div className="max-w-5xl mx-auto" data-id="element-138">
        <FadeIn data-id="element-139">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-brand-brown mb-16" data-id="element-140">
            Si Esto Le Suena Familiar…
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-141">
          {points.map((point, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-142">
              <div className="bg-brand-light p-8 rounded-2xl border border-brand-beige text-center h-full flex flex-col items-center shadow-sm" data-id="element-143">
                <div className="bg-brand-beige p-4 rounded-full mb-6" data-id="element-144">
                  {point.icon}
                </div>
                <p className="text-lg text-brand-dark font-medium leading-relaxed" data-id="element-145">
                  {point.text}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-146">
          <div className="text-center max-w-3xl mx-auto bg-brand-sage bg-opacity-20 p-8 rounded-2xl" data-id="element-147">
            <p className="text-xl text-brand-brown font-serif italic" data-id="element-148">
              "No es su culpa. Estos métodos no funcionan porque atacan el
              síntoma, no la raíz."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}